export default __webpack_public_path__ + "static/img-articolo-ottobre2-d63049fd913ede9875fd292f220538c0.jpg";